import { useEffect } from "react";
import { Link } from "react-router-dom";
import useScrollAnimation from "../../hooks/useScrollAnimation";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";

const STATS = [
  { value: "20+", label: "Yıllık Tecrübe" },
  { value: "1.620+", label: "Tamamlanan Proje" },
  { value: "300+", label: "Mutlu Marka" },
  { value: "18", label: "Aktif Şehir" },
];

const VALUES = [
  {
    icon: "ri-award-line",
    title: "Kalite Odaklı",
    desc: "Malzeme seçimi ve uygulama detaylarında uzun ömür ve güvenilirlik odaklı çalışırız.",
  },
  {
    icon: "ri-time-line",
    title: "Zamanında Teslim",
    desc: "Planlama, üretim ve montaj adımlarını takvimli şekilde yürütür, gecikmeyi en aza indiririz.",
  },
  {
    icon: "ri-team-line",
    title: "Tek Ekip Yönetimi",
    desc: "Keşif, tasarım, üretim ve montaj sürecini tek ekipte yöneterek iletişimi sade tutarız.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Satış Sonrası Destek",
    desc: "Teslim sonrası bakım ve teknik destek ile projelerin sürdürülebilirliğini koruruz.",
  },
];

const STEPS = [
  {
    no: "01",
    title: "Keşif ve Analiz",
    desc: "Mekan ölçüleri, marka ihtiyacı ve bütçe hedefleriyle uygulama kapsamı netleştirilir.",
  },
  {
    no: "02",
    title: "Tasarım ve Planlama",
    desc: "Görsel konsept, teknik çizim ve uygulama takvimi proje başında net bir şekilde hazırlanır.",
  },
  {
    no: "03",
    title: "Üretim ve Montaj",
    desc: "Atölye üretimi tamamlanır, saha montajı kalite standartlarına uygun şekilde yapılır.",
  },
  {
    no: "04",
    title: "Teslim ve Destek",
    desc: "Proje teslimi sonrasında bakım, revizyon ve teknik destek süreci aktif olarak sürdürülür.",
  },
];

const HakkimizdaPage = () => {
  useScrollAnimation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="relative pt-32 pb-20 bg-[#0D0D0D] overflow-hidden">
        <div className="absolute inset-0 opacity-15">
          <img
            src="/images/neden-vip-reklam-806d6601.jpg"
            alt="Hakkimizda"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute top-0 left-0 w-1.5 h-full bg-[#E6A800]" />
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-2 mb-6 anim-down d0">
            <Link to="/" className="text-white/40 text-xs font-head hover:text-[#E6A800] tr uppercase tracking-wider">
              Ana Sayfa
            </Link>
            <i className="ri-arrow-right-s-line text-white/30 text-xs" />
            <span className="text-[#E6A800] text-xs font-head uppercase tracking-wider">Hakkımızda</span>
          </div>
          <div className="flex items-center gap-3 mb-5 anim-left d1">
            <div className="w-8 h-[2px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Kurumsal</span>
          </div>
          <h1 className="font-head font-black uppercase text-white text-[clamp(48px,8vw,100px)] leading-[0.88] anim-up d2">
            Osmaniye'nin
            <br />
            <span className="text-[#E6A800]">Yaratıcı Çözüm Ortağı</span>
          </h1>
          <p className="text-white/50 text-sm leading-relaxed max-w-xl mt-6 anim-up d3">
            Vip Reklam Dekorasyon, Osmaniye'de modern reklamcılık anlayışını benimseyerek
            tabela, tanıtım ve dekorasyon alanlarında yenilikçi çözümler sunar.
            Kaliteli malzeme, doğru uygulama ve uygun fiyat dengesini aynı çatı altında birleştirir.
          </p>
        </div>
      </section>

      <div className="bg-[#E6A800]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex flex-wrap justify-center sm:justify-between divide-x divide-white/25">
            {STATS.map((s) => (
              <div key={s.label} className="flex flex-col items-center px-8 py-5 flex-1">
                <span className="font-head font-black text-white text-2xl leading-none">{s.value}</span>
                <span className="text-white/75 text-[10px] font-head uppercase tracking-wider mt-1">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            <div className="relative anim-left">
              <img
                src="/images/neden-vip-reklam-806d6601.jpg"
                alt="VIP Reklam Atölye ve Uygulama"
                className="w-full h-[520px] object-cover object-center"
              />
              <div className="absolute -bottom-5 -left-5 bg-[#0D0D0D] px-6 py-5 border-l-4 border-[#E6A800]">
                <p className="text-white/60 text-[10px] font-head uppercase tracking-wider">Kuruluş</p>
                <p className="font-head font-black text-white text-3xl leading-none mt-1">2004</p>
              </div>
            </div>

            <div className="anim-right d1">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-8 h-[3px] bg-[#E6A800]" />
                <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Biz Kimiz</span>
              </div>
              <h2 className="font-head font-black uppercase text-[#0D0D0D] text-5xl leading-[0.9] mb-6">
                Markalara Değer Katan
                <br />
                <span className="text-[#E6A800]">Uygulama Ekibi</span>
              </h2>
              <p className="text-[#636363] text-sm leading-relaxed mb-4">
                Osmaniye'de yer alan Vip Reklam Dekorasyon, işletmelerin ve bireylerin
                tanıtım ihtiyaçlarına geniş bir hizmet yelpazesiyle yanıt verir.
                Uzman ekibimiz her projeyi özveriyle ele alır ve sonucu ölçülebilir hale getirir.
              </p>
              <p className="text-[#636363] text-sm leading-relaxed mb-4">
                Yapay çiçek dekorasyonu konusunda da iddialı çözümler üretiyoruz.
                Ev ve iş yerleri için estetik, dayanıklı ve özgün tasarımlarla mekanlara
                canlılık kazandırıyoruz.
              </p>
              <p className="text-[#636363] text-sm leading-relaxed mb-8">
                Müşteri memnuniyetini merkeze alan çalışma anlayışımızla, Osmaniye ve
                çevresindeki markalara göz alıcı ve etkili reklam uygulamaları sunuyoruz.
                İşletmenizin görünürlüğünü artırmak ve kalıcı bir izlenim bırakmak için
                doğru proje planını birlikte oluşturabiliriz.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {VALUES.map((value) => (
                  <div
                    key={value.title}
                    className="p-5 border border-[#E8E8E8] hover:border-[#E6A800] tr bg-white"
                  >
                    <div className="w-9 h-9 flex items-center justify-center bg-[#E6A800]/15 mb-3">
                      <i className={`${value.icon} text-[#E6A800] text-sm`} />
                    </div>
                    <h3 className="font-head font-700 uppercase text-[#111] text-sm mb-2">{value.title}</h3>
                    <p className="text-[#737373] text-xs leading-relaxed">{value.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#F7F7F7]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-3 mb-5 anim-up">
            <div className="w-8 h-[3px] bg-[#E6A800]" />
            <span className="font-head text-[#E6A800] text-xs font-700 uppercase tracking-[0.2em]">Çalışma Modelimiz</span>
          </div>
          <h2 className="font-head font-black uppercase text-[#0D0D0D] text-4xl md:text-5xl leading-[0.9] mb-12 anim-up d1">
            Süreci Net, Sonucu
            <br />
            <span className="text-[#E6A800]">Ölçülebilir Yönetiyoruz</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {STEPS.map((step, i) => (
              <div
                key={step.no}
                className="bg-white border border-[#E8E8E8] hover:border-[#E6A800] tr p-6 anim-up"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div className="flex items-start gap-4">
                  <div className="font-head font-black text-[#E6A800] text-3xl leading-none">{step.no}</div>
                  <div>
                    <h3 className="font-head font-700 uppercase text-[#111] text-lg mb-2">{step.title}</h3>
                    <p className="text-[#6B6B6B] text-sm leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 bg-[#181614]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center anim-scale">
          <div className="w-10 h-[3px] bg-[#E6A800] mx-auto mb-5" />
          <h2 className="font-head font-black uppercase text-white text-4xl md:text-5xl leading-[0.9] mb-5">
            Projenizi Birlikte
            <br />
            <span className="text-[#E6A800]">Planlayalım</span>
          </h2>
          <p className="text-white/60 text-sm leading-relaxed max-w-2xl mx-auto mb-8">
            Hedefinize uygun çözüm için teknik keşif ve bütçe planını birlikte oluşturalım.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/hizmetler"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#E6A800] text-white hover:bg-[#C99500] tr font-head font-700 uppercase text-xs tracking-wider"
            >
              Hizmetleri İncele
              <i className="ri-arrow-right-line" />
            </Link>
            <a
              href="tel:+905511830918"
              className="inline-flex items-center gap-2 px-6 py-3 border border-white/25 text-white hover:bg-white/10 tr font-head font-700 uppercase text-xs tracking-wider"
            >
              <i className="ri-phone-line" />
              +90 551 183 09 18
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HakkimizdaPage;
